import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSelectModule } from '@angular/material/select'
import { MatTableModule } from '@angular/material/table'

import { Substance } from '../../../types/chemistry'
import { TranslationService } from '../../../services/translation.service'

@Component({
  selector: 'app-substance-list',
  imports: [
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    FormsModule,
  ],
  templateUrl: './substance-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './substance-list.component.scss',
})
export class SubstanceListComponent {
  translationService = inject(TranslationService)

  @Input({ required: true }) substances: Array<Substance> = []
  @Input({ required: true }) displayedColumns: Array<string> = []
}
